import * as React from 'react';

import { useRetracked } from 'js/lib/retracked';

import { Accordion, AccordionHeader, AccordionPanel, Typography2 } from '@coursera/cds-core';

import ReactPriceDisplay from 'bundles/payments-common/components/ReactPriceDisplay';
import TeamsPurchaseCheckoutSummary from 'bundles/teams-v2/components/TeamsPurchaseCheckoutSummary';
import type { Props as PropsFromCaller } from 'bundles/teams-v2/components/TeamsPurchaseCheckoutSummary';

import _t from 'i18n!nls/teams-v2';

type PropsToComponent = PropsFromCaller;

const TeamsPurchaseCheckoutSummaryMobile = ({
  learnerCount,
  billingType,
  total,
  todaysTotal,
  organizationName,
  unitPrice,
  showEditLink,
  currency,
  loading,
  discountPercentage,
  discountAmount,
  discountedPrice,
  originalPrice,
  isFreeTrial,
}: PropsToComponent) => {
  const trackComponent = useRetracked();
  let todaysTotalEl = <span>&#8212;</span>;
  if (isFreeTrial) {
    todaysTotalEl = <ReactPriceDisplay value={0} currency={currency} hideCurrencyCode />;
  } else if (!loading && todaysTotal) {
    todaysTotalEl = <ReactPriceDisplay currency={currency} value={parseFloat(todaysTotal)} />;
  }

  const todaysTotalText = isFreeTrial ? _t(`Today's Payment`) : _t('Purchase Summary');

  const handleAccordionChange = () => {
    trackComponent({ trackingData: {}, trackingName: 'mobile_checkout_summary_button', action: 'click' });
  };

  return (
    <Accordion variant="standard" onChange={handleAccordionChange} css={{ width: '100%' }}>
      <AccordionHeader label={todaysTotalText}>
        <Typography2 variant="subtitleMedium" component="div">
          {todaysTotalEl}
        </Typography2>
      </AccordionHeader>
      <AccordionPanel>
        <TeamsPurchaseCheckoutSummary
          total={total}
          isFreeTrial={isFreeTrial}
          todaysTotal={todaysTotal}
          organizationName={organizationName}
          learnerCount={learnerCount}
          billingType={billingType}
          unitPrice={unitPrice}
          showEditLink={showEditLink}
          loading={loading}
          currency={currency}
          discountPercentage={discountPercentage}
          discountAmount={discountAmount}
          originalPrice={originalPrice}
          discountedPrice={discountedPrice}
        />
      </AccordionPanel>
    </Accordion>
  );
};

export default TeamsPurchaseCheckoutSummaryMobile;
